export const COOPERATION_VOUCHER = {
  AOK_BAYERN: 'AOK_BAYERN',
  AOK_NORDOST: 'AOK_NORDOST',
  SALUS_BKK: 'SALUS_BKK',
  VIVIDA_BKK: 'VIVIDA_BKK',
  IKK_CLASSIC: 'IKK_CLASSIC',
  MKK: 'MKK',
  AOK_BREMEN: 'AOK_BREMEN',
  BIG_DIRECT: 'BIG_DIRECT',
} as const;

export type TCooperationVoucherConfig = Record<
  keyof typeof COOPERATION_VOUCHER | 'FALLBACK',
  {
    staging: string;
    production: string;
  }
>;

export const COOPERATION_VOUCHER_CONFIG: TCooperationVoucherConfig = {
  [COOPERATION_VOUCHER.AOK_BAYERN]: {
    staging: 'b4e318d1-c76d-4fde-8e1f-4aaa2146864a',
    production: '921c8f8a-416b-490e-b9a3-18b61c10c8d4',
  },
  [COOPERATION_VOUCHER.AOK_NORDOST]: {
    staging: '2485df2b-638e-4ce3-a6ff-d055d39a553f',
    production: 'e25edb99-1368-438b-8122-6b39f7f3d02a',
  },
  [COOPERATION_VOUCHER.SALUS_BKK]: {
    staging: '9c6bf34c-38e0-4c1d-86e2-6494dd54538f',
    production: '10dcb816-6586-4ea7-bfac-d5327c31008a',
  },
  [COOPERATION_VOUCHER.VIVIDA_BKK]: {
    staging: '53adb93a-8583-427b-891f-4176db1e20fe',
    production: '72cd49d9-7061-4ffe-a880-011a530bd49a',
  },
  [COOPERATION_VOUCHER.IKK_CLASSIC]: {
    staging: 'e79093bb-a248-4239-837b-611b1a01dde2',
    production: '10d1a32a-15cb-4ce8-89fd-b7fab004bf6f',
  },
  [COOPERATION_VOUCHER.AOK_BREMEN]: {
    staging: '1b4dfd61-3374-4b6c-88d0-287a4d717fe4',
    production: '5dd33a7c-19ba-4194-b9cc-d020fe6d1200',
  },
  [COOPERATION_VOUCHER.MKK]: {
    staging: '60f593f8-fb67-4e0b-a2e7-4504c61785e3',
    production: 'e88b7eb3-4878-4afd-b4d0-8b0f3fabf355',
  },
  [COOPERATION_VOUCHER.BIG_DIRECT]: {
    staging: '22b0ddd6-1ed4-4df4-be1d-8c50cb07724d',
    production: '4abd7428-80df-4fbf-a296-f8c0905de4c6',
  },
  FALLBACK: {
    staging: 'fallback-staging',
    production: 'fallback-production',
  },
};

export const getInsuranceNameByClientKey = (clientKey: string): string | null => {
  for (const value of Object.values(COOPERATION_VOUCHER)) {
    const config = COOPERATION_VOUCHER_CONFIG[value];
    if (config?.staging === clientKey || config?.production === clientKey) {
      return value;
    }
  }
  return null;
};
